import { Button } from 'antd';
import React, { useState } from 'react';
import { Assets } from '../../assets';
import { useGet } from '../../hooks/useRest.hook';
import { Endpoints, getResourceUrl } from '../../constants/endpoint.constant';
import { useParams } from 'react-router-dom';
import { pdf } from '@react-pdf/renderer';
import { AccidentDoc } from '../../documents/triporder.doc';
import { prepareTripPdfPayload } from '../../utils/pdf_image.util';
import { saveAs } from 'file-saver';
import { toast } from 'react-toastify';

export const AccidentDetailScreen = () => {
    const { id } = useParams();
    const detailsRq = useGet(Endpoints.ACCIDENT_REPORT(id));
    const [downloading, setDownloading] = useState(false);

    const handleDownload = async () => {
        setDownloading(true);

        try {
            const preparedData = await prepareTripPdfPayload({ accident: detailsRq?.data });
            const blob = await pdf(<AccidentDoc accident={preparedData?.accident} />).toBlob();
            saveAs(blob, `MYC-${detailsRq?.data?.tripOrderId}-accident-report.pdf`);
        } catch (e) {
            toast.error(e?.message || 'Failed to generate accident report PDF');
        } finally {
            setDownloading(false);
        }
    }

    return <>
        <span className='self-center text-lg'>Accident Detail</span>
        <div className='grid grid-cols-3 gap-5 mt-10'>
            <span className="text-center">Name</span>
            <span className="text-center">Number</span>
            <span className="text-center">Email</span>
            <span className="text-center font-bold">{detailsRq?.data?.driverName}</span>
            <span className="text-center font-bold ">{detailsRq?.data?.driver?.user?.number}</span>
            <span className="text-center font-bold">{detailsRq?.data?.driver?.user?.email}</span>
            <span className="text-center">Police Scene</span>
            <div />
            <div />
            <span className="text-center font-bold">{detailsRq?.data?.policeScene ? "YES" : "NO"}</span>
            <div />
            <div />
            <span className="text-center ">Vehicle Towed</span>
            <span className="text-center">Vehicle Make and Model</span>
            <span className="text-center">Vehicle Reg No</span>
            <span className="text-center font-bold">{detailsRq?.data?.vehicleTowed ? "YES" : "NO"}</span>
            <span className="text-center font-bold">{detailsRq?.data?.vehicleMakeModel}</span>
            <span className="text-center font-bold">{detailsRq?.data?.vehicleRegNo}</span>
            <span className="text-center ">Location</span>
            <span className="text-center">Trip Order Ref</span>
            <span className="text-center">Driver Surname</span>
            <span className="text-center font-bold">{detailsRq?.data?.location}</span>
            <span className="text-center font-bold">MYC{detailsRq?.data?.tripOrderId}</span>
            <span className="text-center font-bold">{detailsRq?.data?.driverSurname}</span>

        </div>
        <div className='flex flex-col gap-5 mt-20 items-center'>
            <span>Full Message</span>
            <span>{detailsRq?.data?.description}</span>
            <span>Image</span>
            <div className='grid grid-cols-3 gap-5'>
                {detailsRq?.data?.accidentReportPics?.map?.((M, index) => <img key={`${M?.image || 'accident'}-${index}`} alt="" src={getResourceUrl(M?.image)} className="h-72 w-72 object-contain self-center" />)}
            </div>
            <div className="flex flex-row gap-2">
                {downloading
                    ? <img alt="" src={Assets.Loading} className="w-6 h-6" />
                    : <Button onClick={handleDownload} type='primary' className='px-10'>Download</Button>}
            </div>

        </div >
    </>
}
